module.exports = __webpack_public_path__ + "eb5e2b615b3362d106cc1700cf292aa6.png";